import { createApi } from '@reduxjs/toolkit/query/react';
import config from 'config/index';
import axiosBaseQuery from 'rtk/query/axiosBaseQuery';
import { toast } from 'sonner';
import { EUserType } from 'types/accessControll.types';
import type { TInterviewWithRelations } from 'types/interview.types';
import type { TPaginationInterviewsRequest } from './interviews.api.types';

const reducerPath = 'interviews' as const;
const path = 'v1/interviews' as const;

export const interviewsApi = createApi({
  reducerPath: reducerPath,
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.VITE_BACKEND_URL}/${path}`,
  }),
  endpoints: (builder) => ({
    getInterviewById: builder.query<any, any>({
      query: (payload: { interviewId: string; include: string[] }) => {
        console.log('getInterviews payload', payload);
        let url = `/${payload.interviewId}`;
        url += payload.include.length ? `?include=${payload.include.join(',')}` : '';
        return {
          url: url,
          method: 'GET',
          headers: { 'X-Access-Control': EUserType.ANY },
        };
      },
    }),

    findPaginatedInterviews: builder.query<TInterviewWithRelations, TPaginationInterviewsRequest>({
      query: (x) => {
        console.log('getInterviews x', x);
        return {
          url: `/paginated-find`,
          method: 'POST',
          data: x,
          headers: { 'X-Access-Control': EUserType.ANY },
        };
      },
    }),

    resetInterviews: builder.mutation<
      {
        success: boolean;
        message: string;
        error?: any;
      }[],
      {
        jobId: string | undefined;
        interviewIds: string[];
      }
    >({
      // @ts-ignore
      query: (payload) => {
        if (!payload.jobId) {
          toast.error('No job ID provided.');
          return;
        }

        if (!payload.interviewIds || !payload.interviewIds.length) {
          toast.error('No interview IDs provided.');
          return;
        }

        console.log('testResetInterviews');
        return {
          url: `/reset-interviews-by-id`,
          method: 'POST',
          data: payload,
          headers: { 'X-Access-Control': EUserType.HUBERT },
        };
      },
    }),

    deleteInterviewsById: builder.mutation<
      {
        success: boolean;
        message: string;
        error?: any;
      }[],
      {
        interviewIds: string[];
      }
    >({
      query: (payload) => {
        console.log('testResetInterviews');
        return {
          url: `/delete-interviews-by-id`,
          method: 'POST',
          data: payload,
          headers: { 'X-Access-Control': EUserType.HUBERT },
        };
      },
    }),

    updateManyInterviewSummaries: builder.mutation<any, any>({
      query: (body: { interviewIds: string[] }) => {
        console.log('updateInterviewSummaries body', body);
        return {
          url: `/update-many-interview-summaries`,
          method: 'POST',
          data: body,
          headers: { 'X-Access-Control': EUserType.HUBERT },
        };
      },
      async onQueryStarted(body: { interviewIds: string[] }, { queryFulfilled }: any) {
        try {
          console.log('updateInterviewSummaries onQueryStarted body', body);
          const data = await queryFulfilled;
          // str = PrettyPrintJson({ data: data.data.results })
          toast.success('str');
          console.log('updateInterviewSummaries queryFulfilled data', data);
        } catch (error) {
          toast.error(`Something went wrong. ${error}`);
          console.log('ERROR: updateInterviewSummaries: ', error);
        }
      },
    }),
  }),
});

export const {
  // Queries
  useFindPaginatedInterviewsQuery,

  // Mutations
} = interviewsApi;
